import React, { useState } from 'react';
import DistrictServices from '../services/DistrictServices';
import DistrictStatus from './TogelButton/DistrictStatus'
import useAsync from '../hooks/useAsync';
import Modal from 'react-modal';
import { FaRegEye } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'
import { useNavigate } from 'react-router-dom';
Modal.setAppElement('#root');

function District() {

    const { data, error, isLoading, run } = useAsync(DistrictServices.getState);
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');

    const filteredData = data?.data?.filter(state =>
        state.name.toLowerCase().includes(searchQuery.toLowerCase().trim())
    );

    const handleViewCities = (id) => {
        if (id) {
            window.location.href = `/Cities?id=${id}`;
        }
    };

    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

                    <div className="my-auto">

                        <h5 className="page-title fs-21 mb-1">
                            State List <span className="badge bg-orange">{filteredData?.length || 0}</span>
                        </h5>
                        <nav>

                            <ol className="breadcrumb mb-0">

                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">Home</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    State
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">

                        <div className="pe-1 mb-xl-0">
                            <button className="btn btn-primary me-2" onClick={() => window.location.reload()}>
                                Refresh
                            </button>

                        </div>



                    </div>
                </div>

                <div className="container-box px-0">
                    <div className="Tablesearch_design">
                        <div className="row">
                            <div className='col-md-6'>
                                <div className='d-flex align-items-center justify-content-between gap-2'>
                                    <input
                                        type="search"
                                        name="search"
                                        placeholder="Search by Name, Mobile and Email id"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className='form-control'
                                    />
                                    <button className="search-btn">Search</button>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="container-box-inner table-reponsive-tabe">
                        <table id="example" className="table table-striped" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>State NAME</th>
                                    <th>Status</th>
                                    <th>View Cities</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData?.map((state, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{state.name}</td>
                                        <td className="status-toggle">
                                            <DistrictStatus state={state} page="district" onSuccess={() => run()} />
                                        </td>
                                        <td
                                            onClick={() => handleViewCities(state._id)}
                                            className="view-cities-button"
                                            data-tooltip-id="view-cities-tooltip"
                                            data-tooltip-content=" View City"
                                        >
                                            <FaRegEye className="custom-icon" />
                                            <Tooltip id="view-cities-tooltip" />
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default District;
